const DRPC_API_KEY = process.env.NEXT_PUBLIC_DRPC_API_KEY;

const CHAIN_MAP: Record<string, string> = {
  solana: "solana",
  ethereum: "ethereum",
  bsc: "bsc",
  polygon: "polygon",
  arbitrum: "arbitrum",
  optimism: "optimism",
  zksync: "zksync",
};

const CHAIN_RPC_ENV_MAP: Record<string, string | undefined> = {
  solana: process.env.NEXT_PUBLIC_SOLANA_RPC_URL,
  ethereum: process.env.NEXT_PUBLIC_ETHEREUM_RPC_URL,
};

const isAbsoluteHttpUrl = (value?: string): value is string =>
  !!value && /^https?:\/\//i.test(value);

export function getDrpcUrl(chain: string): string {
  const normalizedChain = chain.toLowerCase();
  const slug = CHAIN_MAP[normalizedChain];
  const envRpcUrl = CHAIN_RPC_ENV_MAP[normalizedChain];

  // Always trust explicit per-chain env URLs as complete endpoints.
  if (isAbsoluteHttpUrl(envRpcUrl)) {
    return envRpcUrl;
  }

  // Support deployments where NEXT_PUBLIC_DRPC_API_KEY is accidentally set to a full dRPC URL.
  // Only use it when the URL matches the requested chain slug.
  if (isAbsoluteHttpUrl(DRPC_API_KEY) && slug) {
    const normalizedDrpcUrl = DRPC_API_KEY.toLowerCase();
    if (normalizedDrpcUrl.includes(`/${slug}/`)) {
      return DRPC_API_KEY;
    }
  }

  if (!slug || !DRPC_API_KEY) {
    if (normalizedChain === "solana") {
      return "https://api.mainnet-beta.solana.com";
    }

    if (normalizedChain === "ethereum") {
      return "https://eth.llamarpc.com";
    }

    return "https://eth.llamarpc.com";
  }

  return `https://lb.drpc.live/${slug}/${DRPC_API_KEY}`;
}

export function getSolanaRpcUrl(): string {
  return getDrpcUrl("solana");
}

export function getEthereumRpcUrl(): string {
  return getDrpcUrl("ethereum");
}
